module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Suset#2-52515c6b8060c1b7be74557ac7a5e381.svg";